// src/components/Admin/BoardGroupManager/index.jsx
import { useState, useEffect, useCallback } from 'react';
import { Box, Typography, Button } from '@mui/material';

import GroupList from './CategoryList';   // 앞서 만든 리스트
import GroupForm from './CategoryForm';   // 앞서 만든 폼

import {
    getBoardGroups,
} from '../../../api/admin';

export default function BoardGroupManager() {
    /* ── Local state ────────────────────── */
    const [groups, setGroups] = useState([]);
    const [openForm, setOpenForm] = useState(false);
    const [currentGrp, setCurrent] = useState(null);
    const [isEdit, setIsEdit] = useState(false);

    /* ── API 호출 ───────────────────────── */
    const loadGroups = useCallback(() => {
        getBoardGroups()
            .then((res) => {
                const sorted = [...(res.data.groups ?? [])].sort(
                    (a, b) => a.order - b.order,
                );
                setGroups(sorted);
            })
            .catch(console.error);
    }, []);

    useEffect(() => loadGroups(), [loadGroups]);

    /* ── 공통 후처리 ────────────────────── */
    const handleAfterChange = () => loadGroups();

    /* ── UI 이벤트 ──────────────────────── */
    const handleAdd = () => {
        setCurrent(null);
        setIsEdit(false);
        setOpenForm(true);
    };
    const handleEdit = (grp) => {
        setCurrent(grp);
        setIsEdit(true);
        setOpenForm(true);
    };

    /* ── Render ─────────────────────────── */
    return (
        <Box sx={{ p: 4, '@media (max-width:600px)': { p: 2 } }}>
            <Typography
                variant="h5"
                gutterBottom
                sx={{ '@media (max-width:600px)': { fontSize: '1.2rem' } }}
            >
                게시판 그룹 관리
            </Typography>

            <Button
                variant="contained"
                onClick={handleAdd}
                sx={{
                    mb: 2,
                    '@media (max-width:600px)': { width: '100%', fontSize: '0.9rem' },
                }}
            >
                ➕ 그룹 추가
            </Button>

            <GroupList
                groups={groups}
                onEdit={handleEdit}
                reload={handleAfterChange}
            />

            {openForm && (
                <GroupForm
                    open={openForm}
                    onClose={() => setOpenForm(false)}
                    group={currentGrp}
                    isEdit={isEdit}
                    reload={handleAfterChange}
                />
            )}
        </Box>
    );
}
